import React from 'react'
import PropTypes from 'prop-types'
import HeroCard from '../HeroCard'
import './MatchList.css'

// Displays a list of Heroes who are compatible with the Summons Match
const MatchList = ({ highlights, heroes, onMatchSelected, selectable, view }) => {
    let classNames = 'match-list-hero'
    //if (selectable) classNames += ' selectable'

    const renderTitle = hero => `${(hero.targetProbability * 100).toFixed(2)}% probability`

    const handleHeroSelected = hero => {
        //selectable && onMatchSelected(hero)
    }

    return heroes.length
        ? heroes.map(hero => (
              <div className={classNames} key={hero.id} onClick={() => handleHeroSelected(hero)}>
                  <HeroCard hero={hero} title={renderTitle(hero)} view={view} highlights={highlights} />
              </div>
          ))
        : null
}

MatchList.propTypes = {
    highlights: PropTypes.object,
    heroes: PropTypes.array,
    onMatchSelected: PropTypes.func,
    selectable: PropTypes.bool,
    view: PropTypes.string,
}

MatchList.defaultProps = {
    onMatchSelected: () => {},
}

export default MatchList
